import React from 'react';
import ThemePreference from './ThemePreference';
import ThemeContext from './themeContext';

const ThemeWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { currentTheme, toggleThemePreference, setThemePreference } = ThemePreference();

    return (
        <ThemeContext.Provider value={{ currentTheme, toggleThemePreference, setThemePreference }}>
            {children}
        </ThemeContext.Provider>
    );
};

export default ThemeWrapper;
